import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

let Line

function EarningsChart({ data }) {
  const cgtColorBrandPrimary = '#19bcc9'
  const [isLoaded, setIsLoaded] = useState()

  useEffect(() => {
    import('react-chartjs-2').then(module => {
      Line = module.Line
      setIsLoaded(true)
    })
  }, [])

  if (!isLoaded) return null

  const chartConfiguration = {
    data: {
      labels: Object.keys(data),
      datasets: [
        {
          label: false,
          data: Object.values(data),
          fill: false,
          backgroundColor: cgtColorBrandPrimary,
          borderColor: cgtColorBrandPrimary,
          borderWidth: 2,
          pointRadius: 2,
          spanGaps: true,
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      tooltips: {
        mode: 'index',
        intersect: false,
        backgroundColor: '#fff',
        bodyFontFamily: '"Source Sans Pro", Helvetica, sans-serif',
        bodyFontColor: cgtColorBrandPrimary,
        bodyFontSize: 14,
        bodyFontStyle: 'semibold',
        xPadding: 10,
        yPadding: 10,
        displayColors: false,
        borderColor: 'rgba(0, 0, 0, 0.15)',
        borderWidth: 2,
        callbacks: {
          title() {},
          label(tooltipItem) {
            return `${tooltipItem.xLabel}: $${tooltipItem.yLabel}`
          },
        },
      },
      hover: {
        mode: 'nearest',
        intersect: true,
      },
      legend: {
        display: false,
      },
      scaleLabel: {
        padding: 4,
      },
      scales: {
        xAxes: [{
          display: true,
          gridLines: {
            display: false,
            color: '#eee',
            zeroLineColor: '#eee',
          },
          ticks: {
            fontFamily: '"Source Sans Pro", Helvetica, sans-serif',
            fontColor: '#6d6d6d',
            fontSize: 12,
          },
        }],
        yAxes: [{
          display: true,
          gridLines: {
            drawBorder: false,
            drawTicks: false,
            color: '#eee',
            zeroLineColor: '#eee',
          },
          ticks: {
            beginAtZero: true,
            padding: 7,
            fontFamily: '"Source Sans Pro", Helvetica, sans-serif',
            fontColor: '#6d6d6d',
            fontSize: 12,
            callback(value) {
              return numeral(value).format('$0,0 a');
            },
          },
        }],
      },
    },
  }

  return (
    <div className="earnings-chart">
      <Line redraw data={chartConfiguration.data} options={chartConfiguration.options} />
    </div>
  )
}

EarningsChart.propTypes = {
  data: PropTypes.object.isRequired,
}

export default EarningsChart
